if ($('.instagram-fetch')[0]) {
	const token = process.env.INSTAGRAM_ACCESS_TOKEN;
	const url = `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type&access_token=${token}&limit=2`;

	fetch(url)
		.then((res) => res.json())
		.then((data) => {
			const container = document.getElementById('insta-feed');
			data.data.forEach((post) => {
				let media = '';
				if (post.media_type === 'IMAGE' || post.media_type === 'CAROUSEL_ALBUM') {
					media = `<i class="fa-brands fa-instagram"></i> <img src="${post.media_url}" alt="${post.caption || ''}" />`;
				} else if (post.media_type === 'VIDEO') {
					media = `<i class="fa-brands fa-instagram"></i> <video controls><source src="${post.media_url}" type="video/mp4"></video>`;
				}
				container.innerHTML += `
				<a href="${post.permalink}" target="_blank">
					${media}
				</a>
				`;
			});
		})
		.catch((err) => console.error('Error fetching Instagram posts:', err));
}
